import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Form, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import MemberHeader from "./MemberHeader";
import { FaArrowAltCircleLeft, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { updateMemberProfileApi } from "../CustomerCRUD";

const MemberMyProfile = () => {
  const [member, setMember] = useState(null);
  const [formData, setFormData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  /* =======================
     LOAD MEMBER (LOCAL / API)
     ======================= */
  useEffect(() => {
    const stored = localStorage.getItem("customer");
    if (stored) {
      const data = JSON.parse(stored);
      setMember(data);
      setFormData(data);
    }
  }, []);

  /* =======================
     HANDLE CHANGE
     ======================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* =======================
     SAVE PROFILE
     ======================= */
  const handleSave = async () => {
    try {
      setLoading(true);

      // 🔹 API call (example)
      // const res = await updateMemberProfileApi(formData);

      // if (res.data.isSuccess) {
      //   localStorage.setItem("customer", JSON.stringify(formData));
      // }

      // Demo success
      localStorage.setItem("customer", JSON.stringify(formData));
      setMember(formData);
      setIsEdit(false);

      toast.success("Profile updated successfully");
    } catch (err) {
      toast.error("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  if (!member) return null;

  return (
    <>
      <MemberHeader />

      <div className="container py-4">
        <Row className="justify-content-center">
          <Col md={8}>
            <Card className="shadow-sm p-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* <h5 className="mb-0" style={{ color: "#FF4F00" }}>
                  👤 My Profile
                </h5> */}
                <p className="mb-1 fw-semibold text-dark px-3 d-flex align-items-center gap-2">
                  <img
                    src={"/assets/logo/300-16.jpg"}
                    alt="Member"
                    className="cursor-pointer rounded-circle border shadow-sm"
                    style={{ width: 45, height: 45, objectFit: "cover" }}
                    // onClick={() => setOpen(!open)}
                  />
                  <span className="fs-5" style={{ color: "#FF4F00" }}>
                    My Profile
                  </span>
                </p>
                {/* <div className="card-header bg-white border-0 "> */}
                <Badge
                  className="text-decoration-none cursor-pointer d-flex"
                  onClick={() => navigate(-1)}
                >
                  <FaArrowAltCircleLeft />
                  &nbsp; back to dashboard
                </Badge>
                {/* </div> */}

                {/* {!isEdit ? (
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => setIsEdit(true)}
                  >
                    Edit Profile
                  </Button>
                ) : (
                  <div className="d-flex gap-2">
                    <Button
                      size="sm"
                      variant="success"
                      onClick={handleSave}
                      disabled={loading}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      variant="secondary"
                      onClick={() => {
                        setFormData(member);
                        setIsEdit(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                )} */}
              </div>

              <Form>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        name="memberName"
                        value={formData.memberName || ""}
                        onChange={handleChange}
                        disabled={!isEdit}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        value={formData.mobileNumber || ""}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Country</Form.Label>
                      <Form.Control
                        value={formData.countryName || ""}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Village / City</Form.Label>
                      <Form.Control
                        name="villageCityName"
                        value={formData.villageCityName || ""}
                        onChange={handleChange}
                        disabled={!isEdit}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Pincode</Form.Label>
                      <Form.Control
                        name="pincode"
                        value={formData.pincode || ""}
                        onChange={handleChange}
                        disabled={!isEdit}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="addressAndText"
                        value={formData.addressAndText || ""}
                        onChange={handleChange}
                        disabled={!isEdit}
                      />
                    </Form.Group>
                  </Col>

                  {/* <Col md={6}>
                    <Form.Group>
                      <Form.Label>Member Since</Form.Label>
                      <Form.Control
                        value={
                          formData.createdDate
                            ? new Date(formData.createdDate).toDateString()
                            : ""
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col> */}
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MemberMyProfile;
